// All translations for the Driver Safety module collected in one place
// to avoid circular dependencies

import { TRANSLATIONS as RiskFactorsSectionComponentTranslations } from "../ui/components/riskFactorsSection/riskFactorsSection";
import { TRANSLATIONS as CollisionRiskSectionComponentTranslations } from "../ui/components/collisionRiskSection/collisionRiskSection";

// Main translations
const mainTranslations = ["Safety"];

// From collisionRiskSection
const collisionRiskSectionTranslations = [
    "Low Risk",
    "Medium Risk",
    "High Risk",
    "At the moment, there is no collision risk data.",
    "Drivers with a risk of",
    "are",
    "{0} times",
    "more likely to be in a collision",
    "Collision Risk Today",
    "During the past week",
    "there have been",
    "{0} risk events",
    "All Time Collision Risk",
    "While the company average is",
    "Risk Score Change",
    "since yesterday",
    "This indicates a",
    "{0}% improvement",
    "{0}% decline",
    "Risk Events",
    "In the past week, there have been {0} {1} events",
    "In the past week, there have been {0} total risk events",
    "Week Avg:",
    "Events",
    "Week total: {0}",
    "Total",
    "Yearly Average Risk Score",
    "Events Logged",
    ...["Best", "Great", "Average", "Underperforming", "At risk", "N/A"]
];

// From riskFactorsSection
const riskFactorsSectionTranslations = [
    "Info Modal Title",
    "Excessive Speeding",
    "Harsh Cornering",
    "Harsh Acceleration",
    "Harsh Braking",
    "Tailgating",
    ...["Acceleration", "Cornering", "Braking", "Speeding", "Tailgating"]
];

// From noDataCard
const noDataCardTranslations = [
    "Safety features are not available for the current vehicle.",
    "No data available"
];

export const DriverSafetyTranslations: string[] = mainTranslations
    .concat(collisionRiskSectionTranslations)
    .concat(riskFactorsSectionTranslations)
    .concat(noDataCardTranslations)
    .concat(RiskFactorsSectionComponentTranslations || [])
    .concat(CollisionRiskSectionComponentTranslations || []);
